import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

// TEMP: add virtual event with name and value to allow Formik to handle form state
const toEvent = (name, value) => ({
  target: {
    name,
    value,
  },
});

const FormField = ({ component, name, onChange, ...props }) => {
  const RenderComponent = component;

  return (
    <Field name={name}>
      {({ field, form }) => (
        <React.Fragment>
          <RenderComponent
            name={field.name}
            value={field.value}
            onChange={value => {
              onChange(toEvent(field.name, value));
              form.setFieldValue(field.name, value);
            }}
            onBlur={event => {
              const fieldName =
                (event && event.target && event.target.name) || field.name;
              form.setFieldTouched(fieldName, true);
            }}
            {...props}
          />
        </React.Fragment>
      )}
    </Field>
  );
};

FormField.propTypes = {
  name: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
  onChange: PropTypes.func,
  automationHook: PropTypes.string,
};

FormField.defaultProps = {
  onChange: Function.prototype,
};

export default FormField;
